const ITEMS = [
  "Petroleum Products",
  "Logistics & Distribution",
  "Door-to-Door Diesel",
  "Dignity in Every Delivery",
  "Nationwide Coverage",
  "Trusted by Top Marketers",
];

export default function Marquee() {
  return (
    <section className="py-12 md:py-16 border-y border-slate-800 bg-[#080E22] overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee-slow w-max items-center">
        {[...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display font-extrabold uppercase tracking-tight text-5xl md:text-7xl mx-8 ${i % 2 === 0 ? "text-outline" : "text-slate-700/60"}`}>
              {item}
            </span>
            <span className="w-3 h-3 rotate-45 bg-amber-600 shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
}
